// @ts-nocheck: converted from JS

import AddButton from '@/components/UI/AddButton';

const Footer = ({ text, onClick }) => {
  return <AddButton onClick={onClick}>{text || 'Add item'}</AddButton>;
};

export default Footer;
